<template>
  <div class="member-select">
    <van-cell :title="label" is-link @click="open = true">
      <template #default>
        <span v-if="selected" class="selected-chip">
          <MemberAvatar :member="selected" :size="18" /> {{ selected.name }}
        </span>
        <span v-else class="muted">請選擇</span>
      </template>
    </van-cell>
    <van-popup v-model="open" position="bottom" round>
      <div class="popup-title">{{ label }}</div>
      <van-cell
        v-for="m in members" :key="m.id"
        clickable @click="choose(m.id)"
      >
        <template #title>
          <span class="row-title"><MemberAvatar :member="m" :size="20" /> {{ m.name }}
            <span v-if="m.isPlaceholder" class="tag-chip">佔位</span>
          </span>
        </template>
        <template #right-icon>
          <van-icon v-if="value === m.id" name="success" color="#ff8f6b" />
        </template>
      </van-cell>
      <van-cell v-if="allowAddPlaceholder" title="＋ 新增佔位成員" clickable @click="addPlaceholder" />
    </van-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MemberAvatar from './MemberAvatar.vue'

export default {
  name: 'MemberSelect',
  components: { MemberAvatar },
  props: {
    value: { type: String, default: null },
    tripId: { type: String, required: true },
    label: { type: String, default: '選擇成員' },
    allowAddPlaceholder: { type: Boolean, default: false }
  },
  data () {
    return { open: false }
  },
  computed: {
    ...mapGetters({ membersByTrip: 'members/byTrip' }),
    members () {
      return this.membersByTrip(this.tripId)
    },
    selected () {
      return this.members.find(m => m.id === this.value) || null
    }
  },
  methods: {
    ...mapActions({ addPlaceholderMember: 'members/addPlaceholder' }),
    choose (id) {
      this.$emit('input', id)
      this.open = false
    },
    addPlaceholder () {
      // eslint-disable-next-line no-alert
      const name = window.prompt('新增佔位成員（只需要填名稱，之後可以認領）')
      if (!name) return
      const id = this.addPlaceholderMember({ tripId: this.tripId, name })
      this.choose(id)
    }
  }
}
</script>

<style scoped>
.selected-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.row-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.popup-title {
  padding: 14px 16px;
  font-weight: 700;
  border-bottom: 1px solid var(--color-border);
}
</style>
